import { render, staticRenderFns } from "./siteindex.vue?vue&type=template&id=5450184a&scoped=true&"
import script from "./siteindex.vue?vue&type=script&lang=js&"
export * from "./siteindex.vue?vue&type=script&lang=js&"
import style0 from "./siteindex.vue?vue&type=style&index=0&id=5450184a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450184a",
  null
  
)

export default component.exports